import React from 'react';
import { outlineTexts } from '../contexts/LangOIT';

function ProductOITOutline({ lang = 'ko', isMobile = false }) {
  return (
    <div
      style={{
        width: '100%',
        minHeight: '100vh',
        background: '#3a3570', // 그라데이션 제거, 단일 컬러
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: isMobile ? '20px 10px' : '0',
        position: 'relative',
        overflowX: 'hidden' // 가로 스크롤 방지
      }}
    >
      {/* 인트로 타이틀 */}
      <div style={{
        textAlign: 'center',
        color: '#fff',
        marginBottom: isMobile ? 20 : 40,
        zIndex: 2,
      }}>
        <h1 style={{
          fontSize: isMobile ? '2rem' : '2.8rem',
          fontWeight: 800,
          marginBottom: isMobile ? 12 : 18,
          letterSpacing: '-1px',
        }}>
          {outlineTexts.title[lang]}
        </h1>
        <div style={{
          fontSize: isMobile ? '1rem' : '1.2rem',
          color: '#fff',
          marginBottom: isMobile ? 8 : 10,
          fontWeight: 400,
        }}>
          {outlineTexts.topic.smalltitle[lang]}
        </div>
        <div style={{
          fontSize: isMobile ? '1.2rem' : '1.45rem',
          color: '#ffb300',
          fontWeight: 700,
        }}>
          {outlineTexts.topic.title[lang]}
        </div>
      </div>
      {/* 아이콘과 기능 박스 */}
      <div
        className="oit-intro-feature-row"
        style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          gap: isMobile ? 20 : 36,
          justifyContent: 'center',
          alignItems: 'stretch',
          width: '100%',
          maxWidth: 1200,
          zIndex: 2,
        }}
      >
        {/* 1번 박스 */}
        <div className="oit-feature-box ani-slide" style={{
          flex: '1 1 320px',
          minWidth: 260,
          maxWidth: 370,
          // background: 'rgba(255,255,255,0.97)',
          background: `#29225C`,
          borderRadius: 18,
          boxShadow: '0 4px 24px rgba(0,0,0,0.10)',
          padding: '40px 28px 32px 28px',
          color: '#29225C',
          fontWeight: 600,
          fontSize: '1.15rem',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
          <svg width="200" height="200" viewBox="0 0 160 260" style={{ marginBottom: 18 }}>
            <HaekerSVG />
          </svg>
          <div style={{ color: '#035BFB', fontSize: '1.08rem', marginBottom: 8 }}>
            {outlineTexts.detection.smalltitle[lang]}
          </div>
          <div style={{ color: '#b74c14', fontWeight: 700, fontSize: '1.50rem', marginBottom: 14 }}>
            {outlineTexts.detection.title[lang]}
          </div>
          <div style={{ color: '#fff', fontWeight: 400, fontSize: '1.08rem', lineHeight: 1.7 }}>
            {outlineTexts.detection.desc[lang]}
          </div>
        </div>
        {/* 2번 박스 */}
        <div className="oit-feature-box ani-slide" style={{
          flex: '1 1 320px',
          minWidth: 260,
          maxWidth: 370,
          background: `#29225C`,
          borderRadius: 18,
          boxShadow: '0 4px 24px rgba(0,0,0,0.10)',
          padding: '40px 28px 32px 28px',
          color: '#29225C',
          fontWeight: 600,
          fontSize: '1.15rem',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
          <svg width="200" height="200" viewBox="0 0 160 200" style={{ marginBottom: 18 }}>
            <ShieldSVG />
          </svg>
          <div style={{ color: '#035BFB', fontSize: '1.08rem', marginBottom: 8 }}>
            {outlineTexts.visibility.smalltitle[lang]}
          </div>
          <div style={{ color: '#b74c14', fontWeight: 700, fontSize: '1.50rem', marginBottom: 14 }}>
            {outlineTexts.visibility.title[lang]}
          </div>
          <div style={{ color: '#fff', fontWeight: 400, fontSize: '1.08rem', lineHeight: 1.7 }}>
            {outlineTexts.visibility.desc[lang]}
          </div>
        </div>
        {/* 3번 박스 */}
        <div className="oit-feature-box ani-slide" style={{
          flex: '1 1 320px',
          minWidth: 260,
          maxWidth: 370,
          background: `#29225C`,
          borderRadius: 18,
          boxShadow: '0 4px 24px rgba(0,0,0,0.10)',
          padding: '40px 28px 32px 28px',
          color: '#29225C',
          fontWeight: 600,
          fontSize: '1.15rem',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
          <svg width="200" height="200" viewBox="0 0 160 200" style={{ marginBottom: 18 }}>
            <PhoneSVG />
          </svg>
          <div style={{ color: '#035BFB', fontSize: '1.08rem', marginBottom: 8 }}>
            {outlineTexts.platform.smalltitle[lang]}
          </div>
          <div style={{ color: '#b74c14', fontWeight: 700, fontSize: '1.50rem', marginBottom: 14 }}>
            {outlineTexts.platform.title[lang]}
          </div>
          <div style={{ color: '#fff', fontWeight: 400, fontSize: '1.08rem', lineHeight: 1.7 }}>
            {outlineTexts.platform.desc[lang]}
          </div>
        </div>
      </div>
      {/* 반투명 배경 효과 */}
      <div style={{
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100vw',
        height: '100vh',
        background: '#3a3570',
        zIndex: 1,
        pointerEvents: 'none'
      }} />
      <style>
        {`
          @media (max-width: 1100px) {
            .oit-intro-feature-row {
              flex-direction: column !important;
              gap: 28px !important;
              align-items: center !important;
              max-width: 500px !important;
            }
          }
          .ani-slide {
            opacity: 0;
            transform: translateX(-80px);
            animation: slideIn 0.8s cubic-bezier(.7,.2,.3,1) forwards;
          }
          .ani-slide:nth-child(1) { animation-delay: 0.1s; }
          .ani-slide:nth-child(2) { animation-delay: 0.3s; }
          .ani-slide:nth-child(3) { animation-delay: 0.5s; }
          @keyframes slideIn {
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }
        `}
      </style>
    </div>
  );
}

function HaekerSVG() {
  const hackerColor = '#333';

  return (
    <g
      style={{
        transition: 'transform 0.13s cubic-bezier(0.23,1,0.32,1)',
      }}
    >
      <path
        d={`
          M-30 190
          A100 100 0 0 1 170 190
          Q150 220 140 247
          Q70 247 0 247
          Q-10 220 -30 190
          Z
        `}
        fill="#333"
        stroke="#888"
        strokeWidth="7"
      />
      <path
        d="
          M20 60
          Q20 20 70 10
          Q120 20 120 60
          Q120 110 70 140
          Q20 110 20 60
          Z
        "
        fill="#444"
        stroke="#444"
        strokeWidth="8"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <path
        d="
          M20 60
          Q20 20 70 10
          Q120 20 120 60
          Q120 110 70 140
          Q20 110 20 60
          Z
        "
        stroke={hackerColor}
        strokeWidth="8"
        fill="none"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <path
        d="M35 82
           Q70 152 105 82
           Q105 62 70 62
           Q35 62 35 82
           Z"
        stroke= '#ff8a80'
        strokeWidth="5"
        fill="none"
      />
      <rect
        x="10"
        y="190"
        width="120"
        height="57"
        rx="12"
        stroke="#035BFB"
        strokeWidth="8"
        fill="#E3EDFF"
      />
    </g>
  );
}

function ShieldSVG() {
  return (
    <g>
      {/* 방패 외곽 - 좌우를 더 넓게 */}
      <path
        d="
        M80 30 
        L135 40 135 80 
        Q125 140 80 170 
        Q35 140 25 80 
        L25 40 80 30 
        Z"
        fill="#E3EDFF"
        stroke="#b74c14"
        strokeWidth="6"
      />
      {/* 방패 중앙 세로선 */}
      <path
        d="M80 45 V150"
        stroke="#b74c14"
        strokeWidth="4"
        strokeLinecap="round"
      />
      {/* 방패 중앙 원 */}
      {/* <circle
        cx="80"
        cy="90"
        r="14"
        fill="#fff"
        stroke="#035BFB"
        strokeWidth="3"
      /> */}
    </g>
  );
}

function PhoneSVG() {
  return (
    <g transform="scale(1.8) translate(-27,-40)">
      {/* 모니터 - 주황색 톤 적용 */}
      <rect
        x="20"
        y="60"
        width="80"
        height="60"
        rx="8"
        fill="#E3EDFF" // 주황색으로 변경
        stroke="#b74c14" // 테두리도 주황 계열로 변경
        strokeWidth="4"
      />
      {/* 모니터 받침대 */}
      <rect
        x="55"
        y="122"
        width="10"
        height="12"
        rx="2"
        fill="#b74c14"
      />
      {/* 모니터 받침대 아래 */}
      <rect
        x="45"
        y="134"
        width="30"
        height="6"
        rx="3"
        fill="#ffd180"
      />
      {/* 핸드폰 (모니터 오른쪽 겹치게) */}
      <rect
        x="85"
        y="80"
        width="28"
        height="48"
        rx="6"
        fill="#fff"
        stroke="#035BFB"
        strokeWidth="3"
      />
      {/* 핸드폰 화면 */}
      <rect
        x="90"
        y="86"
        width="18"
        height="32"
        rx="2"
        fill="#E3EDFF"
      />
      {/* 핸드폰 버튼 */}
      <circle
        cx="99"
        cy="122"
        r="2"
        fill="#035BFB"
      />
    </g>
  );
}

export default ProductOITOutline;